var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-building" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("branches")) + "\n    ")
        ],
        1
      ),
      _c("filters", {
        staticClass: "filter-card",
        attrs: { options: _vm.getOptionsFilter },
        on: {
          requestFiltered: _vm.requestFiltered,
          clearAndRequest: _vm.clearAndRequest
        }
      }),
      _c("q-table", {
        attrs: {
          data: _vm.branches,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          filter: _vm.filter,
          "row-key": "name",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("q-search", {
                  attrs: {
                    debounce: 600,
                    icon: "far fa-search",
                    placeholder: _vm.$t("search")
                  },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                }),
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "far fa-plus",
                    label: _vm.$t("new")
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        name: "admin_branch",
                        params: { id: 0 }
                      })
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "id", attrs: { "auto-width": "", props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.id) +
                          "\n            "
                      )
                    ]
                  ),
                  _c("q-td", { key: "name", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.name) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "fantasy", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.fantasy) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "document", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.document) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "register", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.register) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "company", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.company) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "branch_type", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.getBranchType(props.row.branch_type)) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "managers", attrs: { props: props } },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            color: "primary",
                            "text-color": "white",
                            label:
                              (props.row.managers ||
                                props.row.managers_regional ||
                                props.row.managers_general) &&
                              props.row.managers.length +
                                props.row.managers_regional.length +
                                props.row.managers_general.length,
                            "no-ripple": ""
                          }
                        },
                        [
                          (props.row.managers ||
                            props.row.managers_regional ||
                            props.row.managers_general) &&
                          (props.row.managers.length ||
                            props.row.managers_regional.length ||
                            props.row.managers_general.length)
                            ? _c("q-tooltip", [
                                _c("p", { staticClass: "tooltip q-mb-sm" }),
                                props.row.managers && props.row.managers.length
                                  ? _c(
                                      "div",
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.$t("managers")) +
                                            ":\n                                "
                                        ),
                                        _vm._l(props.row.managers, function(
                                          manager,
                                          index
                                        ) {
                                          return _c("span", { key: index }, [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(manager.full_name) +
                                                "\n                                    "
                                            ),
                                            props.row.managers.length - 1 >
                                            index
                                              ? _c("span", [_vm._v(", ")])
                                              : _vm._e()
                                          ])
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                props.row.managers_regional &&
                                props.row.managers_regional.length
                                  ? _c(
                                      "div",
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t("managers_regional")
                                            ) +
                                            ":\n                                "
                                        ),
                                        _vm._l(
                                          props.row.managers_regional,
                                          function(manager, index) {
                                            return _c("span", { key: index }, [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(manager.full_name) +
                                                  "\n                                    "
                                              ),
                                              props.row.managers_regional
                                                .length -
                                                1 >
                                              index
                                                ? _c("span", [_vm._v(", ")])
                                                : _vm._e()
                                            ])
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                props.row.managers_general &&
                                props.row.managers_general.length
                                  ? _c(
                                      "div",
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.$t("managers_general")) +
                                            ":\n                                "
                                        ),
                                        _vm._l(
                                          props.row.managers_general,
                                          function(manager, index) {
                                            return _c("span", { key: index }, [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(manager.full_name) +
                                                  "\n                                    "
                                              ),
                                              props.row.managers_general
                                                .length -
                                                1 >
                                              index
                                                ? _c("span", [_vm._v(", ")])
                                                : _vm._e()
                                            ])
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _c("p")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    {
                      key: "status",
                      attrs: { props: props, "auto-width": "" }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row.status),
                            color: _vm.getColorStatus(props.row.status)
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "actions", attrs: { props: props } },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "primary",
                            icon: "far fa-pencil-alt"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "admin_branch",
                                params: { id: props.row.actions }
                              })
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                "\n                    "
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "negative",
                            icon: "far fa-trash-alt"
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmRemove(props.row.actions)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("delete_tooltip")) +
                                "\n                    "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }